if (!customElements.get('isolde-load-more')) {
  customElements.define('isolde-load-more', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.button = this.querySelector('button');
        this.fallback = this.querySelector('[data-next-page]');
        this.status = this.querySelector('[data-status]');
        this.error = this.querySelector('[data-error]');
        this.grid = this.closest('.collection').querySelector('#product-grid');
        this.next = this.fallback?.href;
        this.onClick = () => this.load();
        this.button.addEventListener('click', this.onClick);
        this.button.hidden = !this.next;
        if (this.fallback) this.fallback.hidden = true;
        this.initialized = true;
        this.updateCount();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.button?.removeEventListener('click', this.onClick);
      this.initialized = false;
    }
    updateCount() {
      this.status.textContent = this.dataset.countLabel
        .replace('[count]', this.grid.children.length)
        .replace('[total]', this.dataset.total);
    }
    async load() {
      if (this.loading || !this.next) return;
      this.loading = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.loadingLabel;
      this.grid.setAttribute('aria-busy', 'true');
      this.error.textContent = '';
      this.controller = new AbortController();
      try {
        const url = new URL(this.next, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid next-page origin');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected) return;
        const incoming = doc.querySelector('#product-grid');
        if (!incoming || incoming.dataset.id !== this.dataset.section) throw new Error('Missing product grid');
        const cards = Array.from(incoming.children).filter(node => node.matches('li.grid__item'));
        if (!cards.length) throw new Error('Empty next page');
        const nextControl = doc.querySelector('isolde-load-more');
        const nextLink = nextControl?.querySelector('[data-next-page]');
        const nextHref = nextLink ? new URL(nextLink.getAttribute('href'), location.href).href : null;
        if (nextHref === this.next) throw new Error('Repeated next page');
        // Newly appended cards must not remain hidden by the theme's initial scroll animation.
        cards.forEach(card => {
          [card, ...card.querySelectorAll('.scroll-trigger')].forEach(node => {
            node.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          });
        });
        this.grid.append(...cards);
        this.next = nextHref;
        if (nextControl) this.dataset.total = nextControl.dataset.total;
        if (this.fallback && nextHref) this.fallback.href = nextHref;
        this.updateCount();
        this.button.hidden = !nextHref;
        cards[0].querySelector('a[href]')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) this.error.textContent = this.dataset.errorLabel;
      } finally {
        this.loading = false;
        if (this.isConnected) {
          this.button.disabled = false;
          this.button.textContent = this.dataset.buttonLabel;
          this.grid.removeAttribute('aria-busy');
        }
      }
    }
  });
}
